import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-600 via-emerald-500 to-cyan-400 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-4xl backdrop-blur-xl bg-white/15 border border-white/20 rounded-3xl shadow-2xl overflow-hidden">
        
        {/* Top Header */}
        <div className="relative px-6 sm:px-10 py-10 text-center border-b border-white/10">
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 p-4 rounded-full shadow-lg">
              <ShieldCheck className="w-10 h-10 text-white" />
            </div>
          </div>

          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
            Refund Policy
          </h1>

          <p className="mt-3 text-white/80 text-sm sm:text-base max-w-2xl mx-auto">
            Transparent and customer-friendly refund process for all AICA
            subscriptions and services.
          </p>
        </div>

        {/* Main Content */}
        <div className="px-6 sm:px-10 py-8 text-white">
          <div className="bg-white/10 rounded-2xl p-6 sm:p-8 shadow-inner border border-white/10 space-y-6">
            
            <div>
              <h2 className="text-xl font-semibold mb-3 text-white">
                Subscription Refunds
              </h2>

              <p className="text-white/90 leading-relaxed text-sm sm:text-base">
                Our focus is complete customer satisfaction. Subscription Plans
                are refundable upon cancellation, up to{" "}
                <span className="font-semibold text-white">
                  3 working days
                </span>{" "}
                post purchase.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3 text-white">
                Eligible Platforms
              </h2>

              <p className="text-white/90 leading-relaxed text-sm sm:text-base">
                Purchases can be made via{" "}
                <span className="font-semibold">aicahealth.com</span> and{" "}
                <span className="font-semibold">
                  AICA HEALTH mobile / web application(s)
                </span>.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-3 text-white">
                Refund Processing
              </h2>

              <p className="text-white/90 leading-relaxed text-sm sm:text-base">
                The refund processing time is{" "}
                <span className="font-semibold">15 working days</span>.
                Refunds will be credited within{" "}
                <span className="font-semibold">10 working days</span> after
                processing, post deduction of banking and payment gateway
                charges.
              </p>
            </div>
          </div>

          {/* Bottom Action */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-8">
            <p className="text-sm text-white/70 text-center sm:text-left">
              Powered by <span className="font-semibold">AICA</span> | Your
              Smart Health Assistant
            </p>

            <button
              onClick={() => navigate(-1)}
              className="group flex items-center gap-2 bg-white text-teal-700 font-semibold px-5 py-3 rounded-xl shadow-lg hover:scale-105 hover:bg-gray-100 transition-all duration-300"
            >
              <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;